$(document).ready(function () {
  function addItemToCart(variant_id, qty, selling_plan) {
    data = {
      id: variant_id,
      quantity: qty,
      selling_plan: selling_plan,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (response) {
        window.location.href = "/cart";
      },
    });
  }
  var $menu = $(".bc-list");
  $menu.find("li.expanded > a").on("click", function (e) {
    e.preventDefault();
    if ($(this).next("ul.sub-menu").is(":visible")) {
      $(this).removeClass("open");
      $(this).next("ul.sub-menu").slideUp();
    } else {
      $menu.find("li.expanded > a").removeClass("open");
      $(this).addClass("open");
      $menu.find("li.expanded > a").next("ul.sub-menu").slideUp();
      $(this).next("ul.sub-menu").slideToggle();
    }
  });

  var toTop = $(".to-top");
  // logic
  toTop.on("click", function () {
    $("html, body").animate({
      scrollTop: $("html, body").offset().top,
    });
  });
  setTimeout(function () {
    var maxHeight = Math.max.apply(
      null,
      jQuery(
        ".Sharpen-your-trading-egde .card__wrap--inner .card .flexible p,.author_add"
      )
        .map(function () {
          return jQuery(this).innerHeight();
        })
        .get()
    );
    jQuery(
      ".Sharpen-your-trading-egde .card__wrap--inner .card .flexible p,.author_add"
    ).css("min-height", maxHeight + "px");
  }, 200);
  jQuery(window).on("resize", function () {
    setTimeout(function () {
      var maxHeight = Math.max.apply(
        null,
        jQuery(
          ".Sharpen-your-trading-egde .card__wrap--inner .card .flexible p,.author_add"
        )
          .map(function () {
            return jQuery(this).innerHeight();
          })
          .get()
      );
      jQuery(
        ".Sharpen-your-trading-egde .card__wrap--inner .card .flexible p,.author_add"
      ).css("min-height", maxHeight + "px");
    }, 200);
  });

  // tab section

  $(".tabs-nav a").on("click", function (event) {
    event.preventDefault();
    $(".tab-active").removeClass("tab-active");
    $(this).parent().addClass("tab-active");
    $(".tabs-stage .tab-content").hide();
    $($(this).attr("href")).show();
  });
  $(".tabs-nav a:first").trigger("click");

  $('.button-animation-carousel').slick({
        vertical:true,
        verticalSwiping:true,
        slidesToShow: 2.5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed:2000,
        cssEase: 'linear',
        infinite: true,
        arrows:false,
        touchMove:true,
        swipeToSlide:true,
        swipe:true
  })
  
});
$(".custom-quote-slider").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// Element animation — AOS only on non-index pages (GSAP handles index)
if (typeof AOS !== 'undefined') {
  AOS.init({
    duration: 1000,
  });
}

$(document).ready(function () {
  setTimeout(function() {
    var sslPrice = $('.sls-selling-plan-group-price').closest('.sls-purchase-options-container').find('.sls-option-container.sls-active .sls-price span').text();
    originalPrice = sslPrice.replace('US', '');
     $('.sls-selling-plan-group-price').closest('.sls-purchase-options-container').find('.sls-option-container.sls-active .sls-price span').text(originalPrice);
    var subscribeVal = $('.sealsubs-target-element').closest('.shopify-app-block').find('.sls-option-container.sls-active .sls-selling-plan-group-first-line .sls-selling-plan-group-name').text();
     originalVal = subscribeVal.replace('subscription', '');
      $('.sealsubs-target-element').closest('.shopify-app-block').find('.sls-option-container.sls-active .sls-selling-plan-group-first-line .sls-selling-plan-group-name').text(originalVal);
      /* subscribeVal log removed */
      $('.select select').on('change', function (e) {
      setTimeout(function() {
        var sslPrice = $('.sls-selling-plan-group-price').closest('.sls-purchase-options-container').find('.sls-option-container.sls-active .sls-price span').text();
        originalPrice = sslPrice.replace('US', '');
        $('.sls-selling-plan-group-price').closest('.sls-purchase-options-container').find('.sls-option-container.sls-active .sls-price span').text(originalPrice);
        var subscribeVal = $('.sealsubs-target-element').closest('.shopify-app-block').find('.sls-option-container.sls-active .sls-selling-plan-group-first-line .sls-selling-plan-group-name').text();
        originalVal = subscribeVal.replace('subscription', '');
        $('.sealsubs-target-element').closest('.shopify-app-block').find('.sls-option-container.sls-active .sls-selling-plan-group-first-line .sls-selling-plan-group-name').text(originalVal);
        /* test area log removed */
        }, 500);
      });
    }, 2500);
  

// **************** CONTACT SUPPORT BTN TRIGGER JS ***************
  if (document.querySelector('.contact-support-btn')) {
    let isIntercomOpen = false;

    $('.contact-support-btn , .priority-success-section .right-block .wrapper:last-child').on('click', function () {
      if (typeof Intercom === 'function') {
        if (isIntercomOpen) {
          Intercom('hide');
          isIntercomOpen = false;
        } else {
          Intercom('show');
          isIntercomOpen = true;
        }
      }
    });
  }
});
